import Details from './Details';
export type { EventDetailsProps } from '../../components/EventDetail/Details.types';

export default Details;
